// extracted by mini-css-extract-plugin
export default {"FacebookButton":"DisconnectFromFacebookButton_FacebookButton__BqnTm"};